<template>
  <div class="bg-kpis">
    <div class="cr-summary">
      <div class="cr-summary-item text-left" v-if="period">
        <small>Período</small>
        <div class="cr-summary-value">{{ period }}</div>
        <span class="cr-summary-hint" v-if="periodHint">{{ periodHint }}</span>
      </div>
      <div class="cr-summary-item">
        <small>Faturado</small>
        <div class="cr-summary-value">{{ totals.informed | currency }}</div>
        <span class="cr-summary-hint" v-if="hints.informed">{{ hints.informed }}</span>
      </div>
      <div class="cr-summary-item loss">
        <small>Glosado</small>
        <div class="cr-summary-value">−{{ totals.glossed | currency }}</div>
        <span class="cr-summary-hint">{{ glossedHint }}</span>
      </div>
      <div class="cr-summary-item appeal">
        <small>Em recurso</small>
        <div class="cr-summary-value">{{ totals.appealed | currency }}</div>
        <span class="cr-summary-hint" v-if="hints.appealed">{{ hints.appealed }}</span>
      </div>
      <div class="cr-summary-item done">
        <small>Recuperado</small>
        <div class="cr-summary-value">+{{ totals.recovered | currency }}</div>
        <span class="cr-summary-hint" v-if="hints.recovered">{{ hints.recovered }}</span>
      </div>
      <div class="cr-summary-item muted">
        <small>{{ lossLabel }}</small>
        <div class="cr-summary-value">{{ totals.loss | currency }}</div>
        <span class="cr-summary-hint" v-if="hints.loss">{{ hints.loss }}</span>
      </div>
      <div class="cr-summary-item highlight">
        <small>{{ highlightLabel }}</small>
        <div class="cr-summary-value">{{ highlightValue | currency }}</div>
        <span class="cr-summary-hint" v-if="hints.highlight">{{ hints.highlight }}</span>
      </div>
    </div>
    <template v-if="showBar && totals.informed > 0">
      <div class="bg-propbar">
        <span v-for="segment in segments" :key="segment.key" :class="`seg-${segment.key}`"
              :style="{ width: width(segment.share) }"></span>
      </div>
      <div class="bg-legend">
        <span v-for="segment in segments" :key="segment.key">
          <i :class="`seg-${segment.key}`"></i>{{ segment.label }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { num, round2 } from '../helpers';

export default {
  props: {
    totals: {
      type: Object,
      required: true,
    },
    hints: {
      type: Object,
      default: () => ({}),
    },
    period: {
      type: String,
      default: null,
    },
    periodHint: {
      type: String,
      default: null,
    },
    highlight: {
      type: String,
      default: 'toAppeal',
    },
    showBar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lossLabel() {
      return this.highlight === 'released' ? 'Aceito (perda)' : 'Perda assumida';
    },
    highlightLabel() {
      return this.highlight === 'released' ? 'Liberado' : 'A recursar';
    },
    highlightValue() {
      return this.highlight === 'released' ? num(this.totals.released) : num(this.totals.toAppeal);
    },
    glossedHint() {
      const percent = num(this.totals.glossPercent);
      const base = percent ? `${String(percent).replace('.', ',')}% do faturado` : null;
      return [base, this.hints.glossed].filter(Boolean).join(' · ');
    },
    segments() {
      const informed = num(this.totals.informed);
      const recovered = num(this.totals.recovered);
      const appealed = num(this.totals.appealed);
      const accepted = num(this.totals.accepted);
      const open = Math.max(num(this.totals.glossed) - recovered - appealed - accepted, 0);
      const released = Math.max(informed - num(this.totals.glossed), 0);
      return [
        { key: 'released', label: 'Liberado', value: released },
        { key: 'recovered', label: 'Recuperado', value: recovered },
        { key: 'appealed', label: 'Em recurso', value: appealed },
        { key: 'glossed', label: 'Glosado aberto / mantido', value: open },
        { key: 'accepted', label: 'Aceito', value: accepted },
      ]
        .filter(segment => segment.value > 0)
        .map(segment => ({ ...segment, share: round2(segment.value / informed) }));
    },
  },
  methods: {
    width(share) {
      return `${Math.max(Math.min(share * 100, 100), 0)}%`;
    },
  },
};
</script>
